import { __decorate } from "tslib";
import Vue from 'vue';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
import * as msalBrowser from '@azure/msal-browser';
const domain = process.env.VUE_APP_sw5eauthdomain;
export const authConfig = {
    names: {
        signUpSignIn: 'B2C_1_signupin',
        forgotPassword: 'B2C_1_reset'
        // editProfile: "B2C_1_edit_profile"
    },
    authorities: {
        signUpSignIn: {
            authority: `https://${domain}.b2clogin.com/${domain}.onmicrosoft.com/B2C_1_signupin`
        },
        forgotPassword: {
            authority: `https://${domain}.b2clogin.com/${domain}.onmicrosoft.com/B2C_1_reset`
        }
        // editProfile: {
        //     authority: "https://sw5edev.b2clogin.com/sw5edev.onmicrosoft.com/B2C_1_edit_profile"
        // }
    },
    authorityDomain: `${domain}.b2clogin.com`,
    scopes: [
        `https://${domain}.onmicrosoft.com/api/api.readCharacterData`,
        `https://${domain}.onmicrosoft.com/api/api.writeCharacterData`,
        'offline_access'
    ]
};
const msalConfig = {
    auth: {
        clientId: `${process.env.VUE_APP_clientid}`,
        redirectUri: `${process.env.VUE_APP_baseurl}/profile`,
        knownAuthorities: [authConfig.authorityDomain],
        authority: authConfig.authorities.signUpSignIn.authority,
        requireAuthOnInitialize: false
    },
    cache: {
        cacheLocation: 'localStorage'
    }
};
let Authentication = class Authentication extends VuexModule {
    constructor() {
        super(...arguments);
        this.accessToken = null;
    }
    get axiosHeader() {
        return {
            headers: {
                Authorization: `Bearer ${this.accessToken}`
            }
        };
    }
    get account() {
        return Vue.prototype.$msal.getAllAccounts()[0];
    }
    get isLoggedIn() {
        return this.accessToken ? this.accessToken.length > 0 : false;
    }
    async initMSAL() {
        if (!Vue.prototype.$msal)
            Vue.prototype.$msal = new msalBrowser.PublicClientApplication(msalConfig);
        let accessToken = null;
        await Vue.prototype.$msal.handleRedirectPromise().then(tokenResponse => {
            if (tokenResponse && tokenResponse.accessToken) {
                accessToken = tokenResponse.accessToken;
            }
        }).catch((error) => {
            if (error.errorMessage.includes('AADB2C90118')) {
                try {
                    Vue.prototype.$msal.loginRedirect(authConfig.authorities.forgotPassword);
                }
                catch (err) {
                    console.error(err);
                }
            }
            else {
                console.error('Token failure: ' + JSON.stringify(error));
            }
        });
        return { accessToken };
    }
    async setAccessToken(accessToken) {
        return { accessToken };
    }
    async fetchAccessToken() {
        const tokenRequest = { account: Vue.prototype.$msal.getAllAccounts()[0], scopes: authConfig.scopes };
        let accessToken = null;
        try {
            await Vue.prototype.$msal.acquireTokenSilent(tokenRequest).then(tokenResponse => {
                accessToken = tokenResponse.accessToken;
            });
        }
        catch (tokenError) {
            try {
                Vue.prototype.$msal.acquireTokenRedirect(tokenRequest).then();
            }
            catch (tokenRedirectError) {
                console.error('Problem getting token with redirect flow: ' + tokenRedirectError);
            }
        }
        return { accessToken: accessToken || this.state.accessToken };
    }
};
__decorate([
    MutationAction({ mutate: ['accessToken'] })
], Authentication.prototype, "initMSAL", null);
__decorate([
    MutationAction({ mutate: ['accessToken'] })
], Authentication.prototype, "setAccessToken", null);
__decorate([
    MutationAction({ mutate: ['accessToken'] })
], Authentication.prototype, "fetchAccessToken", null);
Authentication = __decorate([
    Module({ namespaced: true, name: 'authentication' })
], Authentication);
export default Authentication;
